import { GetServerSideProps } from 'next';
import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import GiftCardLayout from '@/components/giftCardV2/GiftCardLayout';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest } from '@/hooks/store';
import messages from '@/messages/messages';
import { initGiftPricing } from '@/utils/getInitialState/intiGiftPricing';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const GiftCardPage = () => {
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="gift-card" title={`Calm - ${formatMessage(messages.giftCardPageTitle)}`}>
			<GiftCardLayout />
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const giftPrice = initGiftPricing(
		'annual',
		typeof context?.query?.coupon === 'string' ? context?.query?.coupon : null,
	);
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			giftPrice: giftPrice ?? null,
		},
	);

	return {
		props: {
			initialState,
		},
	};
};

export default GiftCardPage;
